















import {
  defineComponent,
  ref,
  computed,
  PropType,
  inject
} from '@vue/composition-api'
import axios from 'axios'
import FileUploadProgressBar from './FileUploadProgressBar.vue'
import FileTypeIcon from './FileTypeIcon.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { Conversation } from '@/rest/conversations-api'
import { ClientAdminApiKey } from '@/rest/client-admin-api'
library.add(faUpload)

export default defineComponent({
  components: {
    FileUploadProgressBar,
    FileTypeIcon
  },

  props: {
    conversationId: {
      type: String,
      required: true
    },
    conversation: {
      type: Object as PropType<Required<Conversation>>,
      required: true
    },
    file: Object as PropType<File>
  },

  setup(props) {
    const progressEvent = ref(null)
    const uploadPromise = ref<Promise<any>>(null)

    const clientAdminApi = inject(ClientAdminApiKey)

    const upload = async () => {
      const fileType = props.file.name.endsWith('mp3') ? 'audio' : 'video'

      const uploadUrlResponse = await clientAdminApi.UploadUrl(
        props.conversationId
      )

      if (uploadUrlResponse._tag === 'failure') {
        // eslint-disable-next-line
        console.error(`Failed to get signed upload url for inbox:`)
        // eslint-disable-next-line
        console.error(uploadUrlResponse.error)
        return
      }

      const inboxUrl = uploadUrlResponse.data.uploadUrls[fileType]

      uploadPromise.value = axios.put(inboxUrl, props.file, {
        headers: {
          'Content-Type': props.file.type,
          'x-amz-acl': 'bucket-owner-full-control',
          'x-amz-meta-conversation_id': props.conversationId,
          'x-amz-meta-client_id': props.conversation.client_id,
          'x-amz-meta-project_id': props.conversation.project_id,
          'x-amz-meta-team_id': props.conversation.team_id,
          'x-amz-meta-owner_id': props.conversation.owner_id
        },
        onUploadProgress: uploadProgressEvent =>
          (progressEvent.value = uploadProgressEvent)
      })
      await uploadPromise.value
    }

    const canUpload = computed(() => props.file.size > 0)
    const selectedFileName = computed(() => props.file.name || '')

    return {
      upload,
      canUpload,
      selectedFileName,
      progressEvent,
      uploadPromise
    }
  }
})
